import React from 'react';
import { LinkOutIcon } from '@plerionhq/design-system/experimental';

export interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  showExternalIcon?: boolean;
}

const defaultClassName =
  'text-orange-600 hover:text-orange-700 hover:underline';
const withIconClassName =
  'inline-flex items-center gap-1 text-sm font-medium text-orange-600 hover:text-orange-700 hover:underline';

export const ExternalLink: React.FC<ExternalLinkProps> = ({
  href,
  children,
  className,
  showExternalIcon = false,
}) => {
  const resolvedClassName =
    className ?? (showExternalIcon ? withIconClassName : defaultClassName);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={resolvedClassName}
    >
      {children}
      {showExternalIcon && (
        <LinkOutIcon
          href={href}
          className="h-3 w-3 flex-shrink-0"
          aria-hidden
        />
      )}
    </a>
  );
};
